import { makeStyles } from 'tss-react/mui';
import { Modal, ModalActions, ModalContent, ModalProps } from '../../../Modal';
import { Button } from '../../../Button';
import { Alert } from '../../../Alert';
import { AdminInsuranceDetails } from './admin-insurance-details';
import { Box, Typography } from '@mui/material';
import { Form, Formik } from 'formik';
import { InsuranceBenefitsFormType, useBenefitsForm } from '../hooks/use-benefits-form.hook';
import { InsuranceBenefitsForm } from '../forms/insurance-benefits-form.form';
import { InsuranceDataType } from '../Settings/types';

export type ArchivedInsuranceRestoreModalProps = {
  insuranceData: InsuranceDataType;
  onRestoreInsurance: (benefits: InsuranceBenefitsFormType) => Promise<void>;
  restoreLoading?: boolean;
  onClose: () => void;
  isRestoreAsSecondary?: boolean;
} & ModalProps;

export const ArchivedInsuranceRestoreModal: React.FC<ArchivedInsuranceRestoreModalProps> = ({
  insuranceData,
  onRestoreInsurance,
  restoreLoading,
  isRestoreAsSecondary,
  ...props
}) => {
  const { insuranceBenefitsFormik } = useBenefitsForm(insuranceData);
  const { initialValues, validationSchema } = insuranceBenefitsFormik();
  const { classes: modalClasses } = useModalStyles();

  const onRestore = async (values: InsuranceBenefitsFormType) => {
    await onRestoreInsurance(values);
    props.onClose();
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={!isRestoreAsSecondary ? validationSchema : undefined}
      onSubmit={onRestore}
    >
      <Modal
        title="Restore Insurance"
        maxWidth="md"
        fullWidth
        classes={modalClasses}
        loading={restoreLoading}
        {...props}
      >
        <Form>
          <ModalContent dividers>
            <Alert severity="info" showIcon={false}>
            Confirm all insurance details are correct and verify benefit information directly with the payer.
            </Alert>
            <Box mt={4}>
              <AdminInsuranceDetails insuranceData={insuranceData} />
            </Box>
            {!isRestoreAsSecondary && (
              <Box mt={4}>
                <Typography fontWeight={500} mb={2}>Benefits</Typography>
                <InsuranceBenefitsForm />
              </Box>
            )}
          </ModalContent>
          <ModalActions>
            <Button disabled={restoreLoading} onClick={props.onClose}>
            Cancel
            </Button>
            <Button disabled={restoreLoading} color="secondary" variant="contained" type="submit">
              Restore As {isRestoreAsSecondary ? 'Secondary' : 'Primary'} Insurance
            </Button>
          </ModalActions>
        </Form>
      </Modal>
    </Formik>
  );
};


const useModalStyles = makeStyles()({
  paperWidthMd: {
    width: '600px',
    maxWidth: '600px'
  },
});
